export default __webpack_public_path__ + "static/media/logo_TeamIT.910c072a.svg";